import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {DocketSelectorAuditReportModel} from "./docket-selector-audit-report-model.service";
import {MetaTagType} from "../../meta-tag/meta-tag.data";

@Component({
    selector: "wbo-docket-selector-audit-report-page",
    templateUrl: "./docket-selector-audit-report-page.component.html",
    providers: [provideReportModel(DocketSelectorAuditReportModel)]
})
export class DocketSelectorAuditReportPageComponent extends AbstractReportPage {

    MetaTagType = MetaTagType;

    constructor(public model: DocketSelectorAuditReportModel) {
        super();
    }
}
